import { VideoServiceType } from 'domains/models/calendar/videoServiceType';
import { VisibilityType } from 'domains/models/user_calendar/visibilityType';
import { CalendarEventListItem } from 'presentations/api/schema/calendar_event';
import { translate } from 'infras/i18n';

export function formatVideoServiceName(event: CalendarEventListItem) {
  switch (event.videoServiceType) {
    case VideoServiceType.GoogleMeet:
      return 'Google Meet';
    case VideoServiceType.Zoom:
      return 'Zoom';
    case VideoServiceType.Jicoo:
      return 'Jicoo';
    case VideoServiceType.MicrosoftTeams:
      return 'Teams';
    default:
      break;
  }
  return null;
}

export function formatEventName(
  defaultName: string | null,
  visibilityType?: VisibilityType,
) {
  if (visibilityType === VisibilityType.Busy || !defaultName) {
    return translate('model.CalendarEvent.name.busy');
  }

  return defaultName;
}
